import styled from '@emotion/styled';

const Container = styled.div`
  .loading {
    width: 100%;
    padding: 17px 0px 4px 0px;
    display: flex;
  }

  .loading .line {
    border-radius: 5px;
    background: rgba(130, 130, 130, 0.2);
    background: -webkit-gradient(
      linear,
      left top,
      right top,
      color-stop(8%, rgba(130, 130, 130, 0.2)),
      color-stop(18%, rgba(130, 130, 130, 0.3)),
      color-stop(33%, rgba(130, 130, 130, 0.2))
    );
    background: linear-gradient(
      to right,
      rgba(130, 130, 130, 0.2) 8%,
      rgba(130, 130, 130, 0.3) 18%,
      rgba(130, 130, 130, 0.2) 33%
    );
    animation: wave-lines 2s infinite ease-out;
  }

  .loadings {
    flex: 2;
  }

  .loading .line:last-child {
    margin-bottom: 0;
  }

  .hw1 {
    height: 31px !important;
    margin-top: 7px !important;
    width: 100px !important;
  }

  .hm2 {
    margin-top: 12px;
    height: 16px;
  }

  @keyframes wave-lines {
    0% {
      background-position: -468px 0;
    }

    100% {
      background-position: 468px 0;
    }
  }

  @media screen and (max-device-width: 375px) {
    .hm2 {
      margin-top: 12px;
      height: 29px;
    }
  }

  @media screen and (max-device-width: 320px) {
    .hw1 {
      margin-top: 7px !important;
      height: 15px !important;
    }

    .hw3 {
      height: 20px !important;
    }
  }
`;

function Loading() {
  return (
    <Container>
      <div className='loading'>
        <div className='loadings'>
          <div className='line hw1'></div>
          <div className='line hm2'></div>
        </div>
      </div>
    </Container>
  );
}

export default Loading;
